import { useEffect } from 'react';

let locked = 0;

export const useLockGlobalScroll = (lock: boolean) => {
  useEffect(() => {
    locked += 1;
    if (lock) {
      window.document.body.classList.add('modal-open');
    } else {
      window.document.body.classList.remove('modal-open');
    }
    if (locked > 1) {
      console.warn(
        'More than one instance of useLockGlobalScroll at the same time.',
        'This may lead to premature unlocking.'
      );
    }
    return () => {
      locked -= 1;
      window.document.body.classList.remove('modal-open');
    };
  }, [lock]);
};
